import baseTemplate from "./pdp-login.html";

export default baseTemplate;
